import {
  ChangeDetectorRef,
  Directive,
  HostBinding,
  Input,
} from '@angular/core';
import { HookDirective } from '../core/hook';
import { useSubscriptionLatest } from '../core/hooks';
import { PhiService } from './phi.service';

@Directive({ selector: '[phi]' })
export class PhiDirective extends HookDirective {
  constructor(
    private readonly phiService: PhiService,
    _cdr: ChangeDetectorRef,
  ) {
    super(_cdr);
  }
  @Input() phi: boolean;
  @HostBinding('class') private baseClass = 'rv-phi';
  @HostBinding('class.obscure') get obscure() {
    return this.phi !== false && this._.obscure;
  }
  get _() {
    const obscure = useSubscriptionLatest(this.phiService.obscure, []);
    return { obscure };
  }
}
